// Once we have fully upgraded to React 15 and all instances of valueLink
// have been accounted for we can remove this file.

export function valueLinkDeprecation(props){
  if(props.valueLink){
    console.error('The use of \'valueLink\' is deprecated. Explicitly set the value and change handler. https://facebook.github.io/react/docs/two-way-binding-helpers.html');
  }
}
